import { SnackbarService } from './../../../services/snackbar/snackbar.service';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import axios from 'axios';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { environment } from '../../../../environments/environment';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    MatGridListModule,
    MatCardModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    CommonModule,
    MatIconModule,
    MatCheckboxModule,
    ReactiveFormsModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login {
  loginForm: FormGroup;
  hide = signal(true);
  loginErrorMessage = signal('');

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly snackbarService: SnackbarService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      senha: ['', [Validators.required]],
      aceitarPolitica: [false, [Validators.requiredTrue]],
    });
  }

  showOrHidePassword(event: MouseEvent) {
    this.hide.set(!this.hide());
    event.stopPropagation();
  }

  togglePrivacyPolicy() {
    const checkbox = this.loginForm.get('aceitarPolitica');
    if (checkbox) {
      checkbox.setValue(!checkbox.value);
    }
  }

  async defaultAuthentication() {
    this.loginErrorMessage.set('');

    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    sessionStorage.removeItem('token');

    const { email, senha } = this.loginForm.value;

    try {
      const res = await axios.post(`${environment.apiUrl}/auth/login`, {
        email,
        senha,
      });

      const token = res.data?.data;
      if (!token){
        throw new Error('Token não encontrado na resposta');
      }

      this.token = token;
      sessionStorage.setItem('token', this.token);
      this.router.navigate(['/home']);

    } catch (err) {
      this.loginErrorMessage.set('E-mail ou senha inválidos.');
      this.snackbarService.error('E-mail ou senha inválidos.');
    }
  }

  getEmailErrorMessage(): string {
    const emailControl = this.loginForm.get('email');

    if (emailControl?.hasError('required')) {
      return 'Campo obrigatório';
    }
    return emailControl?.hasError('email') ? 'E-mail inválido' : '';
  }

  getPasswordErrorMessage(): string {
    return this.loginForm.get('senha')?.hasError('required')
      ? 'Campo obrigatório'
      : '';
  }

  abrirPoliticaDePrivacidade() {
    const fileName = 'Política de Privacidade - Portal.pdf';
    const pdfUrl = 'assets/docs/' + encodeURIComponent(fileName);
    window.open(pdfUrl, '_blank');
  }

  token: string = '';
}
